import { z } from "zod";

/** API: GUID with hyphens (D) or 32 hex chars without hyphens (N). */
const guidSchema = z.union([z.guid(), z.hex().length(32)]);

export function tryParseGuid(value: string | null | undefined): string | null {
    const trimmed = value?.trim();
    if (!trimmed) {
        return null;
    }

    return guidSchema.safeParse(trimmed).success ? trimmed : null;
}
